var React = require('react');

function PolygonOrange (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M149.5 0L298.023 257.25H0.976639L149.5 0Z","fill":"#FCDBBB"}));
}

PolygonOrange.defaultProps = {"width":"299","height":"258","viewBox":"0 0 299 258","fill":"none"};

module.exports = PolygonOrange;

PolygonOrange.default = PolygonOrange;
